var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatMobileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 34,
    r: 34,
    fill: "#FFC93C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.25 37.75C45.25 38.413 44.9866 39.0489 44.5178 39.5178C44.0489 39.9866 43.413 40.25 42.75 40.25H27.75L22.75 45.25V25.25C22.75 24.587 23.0134 23.9511 23.4822 23.4822C23.9511 23.0134 24.587 22.75 25.25 22.75H42.75C43.413 22.75 44.0489 23.0134 44.5178 23.4822C44.9866 23.9511 45.25 24.587 45.25 25.25V37.75Z",
    stroke: "#163165",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatMobileIcon);
export default __webpack_public_path__ + "static/media/chat-mobile-icon.c8b3109cf361bd9d1af3bccf34b38168.svg";
export { ForwardRef as ReactComponent };